import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getPublicSettings, PublicSettings } from '../services/settingsService';

interface SettingsContextType extends PublicSettings {
  loading: boolean;
  refresh: () => Promise<void>;
}

const defaultSettings: SettingsContextType = {
  ordersEnabled: true,
  loading: true,
  refresh: async () => {}
};

const SettingsContext = createContext<SettingsContextType>(defaultSettings);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ordersEnabled, setOrdersEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await getPublicSettings();
      setOrdersEnabled(data.ordersEnabled);
    } catch {
      setOrdersEnabled(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value: SettingsContextType = {
    ordersEnabled,
    loading,
    refresh
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
